import { displayText } from '../../../../../terminology/store';
import { useTerminology } from '../../../../../terminology/TerminologyContext';
import React, { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ThemeContext from '../../../../ThemeContext';
import api from '../../../../services/api';
import { URL_SEGMENTS } from '../../../../../config/Routesconfig';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

const SampleCase = () => {
  useTerminology();
  const { theme }    = useContext(ThemeContext);
  const { username } = useParams();
  const navigate     = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError]         = useState(null);

  const fontFamily    = theme?.typography?.fontFamily
    || '"Roboto", "Helvetica Neue", Arial, sans-serif';
  const bodyFontSize  = theme?.typography?.bodyFontSize  || 14;
  const smallFontSize = Math.max(bodyFontSize - 2, 10);

  useEffect(() => {
    const ensureSampleCase = async () => {
      try {
        setIsLoading(true);
        setError(null);

        const response = await api.get('/sample-case/ensure');
        const sampleCaseId = response.data?.data?.id;

        if (!sampleCaseId) {
          throw new Error('No sample case ID returned from server');
        }

        navigate(
          `/${username}/dashboard/${URL_SEGMENTS.sampleCase}/${sampleCaseId}`, 
          { replace: true }
        );

      } catch (err) {
        console.error('SampleCase ensure error:', err);
        const msg = err.response?.data?.message
          || err.message
          || 'Failed to load sample case';
        setError(msg);
        setIsLoading(false);
        toast.error(msg);
      }
    };

    ensureSampleCase();
  }, [username, navigate]);

  // ── Loading ───────────────────────
  if (isLoading) {
    return (
      <div style={{
        position      : 'fixed',
        top           : '50%',
        left          : '50%',
        transform     : 'translate(-50%, -50%)',
        display       : 'flex',
        flexDirection : 'column',
        alignItems    : 'center',
        gap           : '1rem',
        zIndex        : 9999,
        fontFamily,
      }}>
        <div style={{
          width        : '40px',
          height       : '40px',
          border       : `4px solid ${theme.colors.primary}`,
          borderTop    : '4px solid transparent',
          borderRadius : '50%',
          animation    : 'spin 1s linear infinite',
        }} />
        <span style={{
          fontSize : `${smallFontSize}px`,
          color    : theme.colors.textSecondary,
        }}>{displayText(" Setting up your sample case... ")}</span>
        <style>{`
          @keyframes spin {
            0%   { transform: rotate(0deg);   }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  // ── Error ─────────────────────────
  if (error) {
    return (
      <div style={{
        textAlign  : 'center',
        padding    : '3rem',
        fontFamily,
        fontSize   : `${bodyFontSize}px`,
        color      : theme.colors.textPrimary,
      }}>
        <i className="bi bi-exclamation-triangle" style={{
          fontSize     : '2rem',
          color        : theme.colors.danger,
          display      : 'block',
          marginBottom : '1rem',
        }} />
        <p style={{ marginBottom: '1rem', color: theme.colors.danger }}>
          {error}
        </p>
        <button
          onClick={() =>
            navigate(`/${username}/dashboard/${URL_SEGMENTS.cases}`)
          }
          style={{
            background   : theme.gradients.secondary,
            color        : theme.colors.textWhite,
            border       : 'none',
            padding      : '0.5rem 1rem',
            borderRadius : '8px',
            cursor       : 'pointer',
            fontSize     : `${smallFontSize}px`,
            fontFamily,
          }}
        >{displayText(" Back to Cases ")}</button>
      </div>
    );
  }

  return null;
};

export default SampleCase;